export default "__VITE_ASSET__DJHDcOaZ__"